module.exports = require("./createClass.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/helpers/create-class.js
 ** module id = 14
 ** module chunks = 0
 **/